import { Injectable } from '@angular/core';

/**
 * Задача что prizmTh
 * */
@Injectable()
export class PrizmThGroupService {}
